
import { useAuth } from "@/hooks/useAuth";
import { useAdminRole } from "@/hooks/useAdminRole";
import { Navigate } from "react-router-dom";
import RetroactiveModerationAdmin from "@/components/admin/RetroactiveModerationAdmin";
import ContentModerationPanel from "@/components/admin/ContentModerationPanel";
import TestUserManager from "@/components/admin/TestUserManager";
import TestBuzzzSender from "@/components/admin/TestBuzzzSender";
import KinkipediaAdmin from "@/components/admin/KinkipediaAdmin";
import MessageDistributionAdmin from "@/components/admin/MessageDistributionAdmin";
import AdminWelcomeMessageSender from "@/components/admin/AdminWelcomeMessageSender";
import RightSideMenu from "@/components/navigation/RightSideMenu";
import AdPanel from "@/components/ads/AdPanel";
import { AlphaLoader } from "@/components/ui/alpha-loader";

const ContentModerationAdmin = () => {
  const { isAdmin, loading: adminLoading } = useAdminRole();

  if (adminLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-50 flex items-center justify-center">
        <AlphaLoader size="large" />
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/discovery" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-50 p-4 pb-20">
      <RightSideMenu />
      <AdPanel />
      
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            Content Moderation Admin
          </h1>
          <p className="text-gray-600">Manage and moderate platform content with enhanced Apple Store compliance</p>
        </div>

        <div className="grid gap-6">
          <TestUserManager />
          <TestBuzzzSender />
          <AdminWelcomeMessageSender />
          <MessageDistributionAdmin />
          <KinkipediaAdmin />
          <RetroactiveModerationAdmin />
          <ContentModerationPanel />
        </div>
      </div>
    </div>
  );
};

export default ContentModerationAdmin;
